import breakpoints from "../tokens/breakpoints";
import { ThemeProperties } from "../theme.types";

export const storyTheme: ThemeProperties = {
  name: "story",
  title: "Rendu Photoréaliste STORY",

  assets: {
    logo: "/themes/story/STORY_logo.png",
    favicon: "/themes/story/Picto_STORY_Cosika.jpg",
  },

  gradients: {
    headerBackground:
      "linear-gradient(180deg, #1d1d1b 0%, #1d1d1b 100%)",
  },

  breakpoints: breakpoints,
};
